import { c as _c } from "react/compiler-runtime";
import { sceneSeatsAvailableSelector } from "@store/scene-seats/scene-seats-selector";
import { activeSeatsAvailableSelector } from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";
/** Returns how many seats of each kind the workspace still has free to give to a member */
export function useSeatsAvailable() {
  const $ = _c(3);
  const xgSeatsAvailable = useAppSelector(activeSeatsAvailableSelector);
  const sceneSeatsAvailable = useAppSelector(sceneSeatsAvailableSelector);
  const t0 = xgSeatsAvailable ?? 0;
  let t1;
  if ($[0] !== sceneSeatsAvailable || $[1] !== t0) {
    t1 = {
      xgSeat: t0,
      sceneSeat: sceneSeatsAvailable
    };
    $[0] = sceneSeatsAvailable;
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}